import { Components } from "~/OmnichannelApi/openapi";

export interface JobPostingEvents {
  position_apply_success: JobPostingEventMetaData;
  position_apply_start: JobPostingEventMetaData;
  position_apply_popup_voluntary: JobPostingEventMetaData;
  position_apply_interest: JobPostingEventMetaData;
  position_apply_validation_error: JobPostingEventMetaData;
}

export interface JobPostingEventMetaData {
  job_id: string;
}

export const createJobPostingEventMetaData = (
  job: Components.Schemas.Job
): JobPostingEventMetaData => {
  return {
    job_id: job.job_id,
  };
};
